module.exports = __webpack_public_path__ + "images/products/subscription-view-0af80c65.png";